import { ResourceContainer } from 'ohzi-core';

import MenuViewMode from './MenuViewMode';
/*
import PhysicalCameraManager from '../../PhysicalCameraManager';
import MenuCameraManager from '../../MenuCameraManager';
import GeofenceManager from '../../GeofenceManager';
import TaglockMarkerManager from '../../TaglockMarkerManager';
import PlayerSettings from '../../PlayerSettings';
import CameraObjectManager from '../../CameraObjectManager';
import LprManager from '../../LprManager';
*/

// This represents the Recordings mode of the MenuView
/**
 * @class RecordingsMode
 * @description User is able to see his Recordings files.Get activated when Recordings tab is clicked.
 * @function on_tab_selected() - Get called when user has clicked the tab. (called by MenuView).
 * @function on_player_hide() -  Get called when we want to hide the player. (called by PlayerContainer)
 * @function is_valid_camera() -  It works as filter for whcich camera to display in the menu view.Called by menuView.js
 * 
 */
export default class RecordingsMode extends MenuViewMode
{
  constructor()
  {
    super('recordings');
  }

  on_tab_selected(menu_view)
  {
    if (PhysicalCameraManager.selected_camera) PhysicalCameraManager.selected_camera.show_player_on_zoom = false;
    menu_view.fill_menu(0);
    GeofenceManager.hide_geofence();
    TaglockMarkerManager.remove_all_markers();
    LprManager.remove_object();
    PlayerSettings.set_recordings_mode();
    CameraObjectManager.set_recordings_mode();

    // Automatically select camera (as only ever one camera in standalone mode) (NOT WORKING)
    /*
    let camera = PhysicalCameraManager.cameras[0];
    console.dir(camera);
    if (camera)
    {
      menu_view.select_physical_camera(camera);
    }
    */
  }

  is_valid_camera(physical_camera)
  {
    return (physical_camera.bodyworn !== 'yes' && physical_camera.cam_type !== 'phone');
  }

  on_player_hide(player_container)
  {
    player_container.app.recording_telemetry_controller.stop_streaming(PhysicalCameraManager.selected_camera);
  }

  on_camera_selected(menu_view)
  {
    console.log(`[on_camera_selected]`)
    menu_view.show_calendar_view();

    menu_view.app.calendar_view.get_recordings_from_camera(PhysicalCameraManager.selected_camera);

    /*if (!app.mode_optimized)
    {
      menu_view.app.calendar_view.get_events_from_camera(PhysicalCameraManager.selected_camera);
    }*/
  }

  on_day_selected(app)
  {
    let first_fragment = app.player_view.playback_bar.get_first_fragment();
    app.player_view.play_recording(first_fragment);

    app.player_view.extract_recording_view.show_open_button();
    //app.player_container.show();
    app.menu_view.hide_calendar_view();
    app.menu_view.close();

    let camera = PhysicalCameraManager.selected_camera;
    if (app.mode_multi_camera)
    {
      camera.show_player_on_zoom = true;
      //camera.fly_on_valid_telemetry = true;
      //camera.show_map_marker(false);
      camera.fly_to_camera_marker();

      setTimeout(function() { 
        // If player has not opened on zoom for some reason force open player after a time
        if (camera.show_player_on_zoom)
        {
          //menu_view.app.player_container.show_fade();
          //PhysicalCameraManager.selected_camera.show_player_on_zoom = false;
        }
      }.bind(this), 10000);

    }
    else
    {
      app.player_container.show();
      //app.menu_view.hide_calendar_view();
      //app.menu_view.close();
    }

    // TODO: TEMP Disable for ADSB PhysicalCameraManager.selected_camera.fly_on_valid_telemetry = true;
  }

  on_recording_played(player_view, fragment)
  {
    console.log('[RecordingsMode:on_recording_played]');

    if (PhysicalCameraManager.selected_camera.has_telemetry()) {
      player_view.app.recording_telemetry_controller.stop_streaming(PhysicalCameraManager.selected_camera);
    }

    // Set recording id and time to the selected setram
    PhysicalCameraManager.selected_camera.stream.set_recording_data(
      fragment.id,
      fragment.get_relative_offset_ms(player_view.playback_time) / 1000,
      fragment.recording.start_date
    );

    // Set Recording profle to the selected stream (rec_profile is variable that is loaded dynamically from camera settings)
    PhysicalCameraManager.selected_camera.stream.set_profile(PhysicalCameraManager.selected_camera.rec_profile);

    if (PhysicalCameraManager.selected_camera.stream_type.includes('webrtc_whep')) {
      // MediaMTX recording playback
      PhysicalCameraManager.selected_camera.stream.stop_streaming();
      player_view.app.player_container.show_loading();

      let play_offset = fragment.get_relative_offset_ms(player_view.playback_time) / 1000;
      let startDateM = moment.parseZone(fragment.recording.absolute_start_date, ['YYYY-MM-DDTHH:mm:ss.SSSSSSZZ', 'YYYY-MM-DDTHH:mm:ssZ']).add(play_offset,'seconds');

      // The url must be constructed here once we know the playback time
      // The start time must be in RFC 3339 format: 2024-06-16T23:48:10+00:00
      let url = `${fragment.recording.encodedurl}&start=${encodeURIComponent(startDateM.format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'))}&duration=99999`;
      // The request must be proxied via the recording API as the camera MediaMTX server could be on private IP
      let app_config = ResourceContainer.get_resource('config');
      let proxied_url = `${app_config.recordings_api_host}/proxy_stream?url=${encodeURIComponent(url)}`;

      console.log(`[on_recording_played] play_offset: ${play_offset} (${play_offset/1000}
        recording_start_offset: ${fragment.recording_start_offset} (${fragment.recording_start_offset/1000})
        absolute_start_date: ${fragment.recording.absolute_start_date}
        absolute_end_date: ${fragment.recording.absolute_end_date}
        get start time: ${startDateM.format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ')}
        url: ${proxied_url}`);
      
      player_view.extract_recording_view.start_streaming(
        player_view.play.bind(player_view),
        fragment.get_relative_offset_ms(player_view.playback_time) / 1000,
        player_view.html_video,
        //fragment.recording.encodedurl
        proxied_url
      );
    } else {
      // Axis camera recording playback
      // player_view.play is passed as a callback, so the AxisCameraStream can call it
      // when the RTSP connection is ready to stream
      PhysicalCameraManager.selected_camera.stream.start_streaming(player_view.play.bind(player_view));
    }
  }
}
